import React from 'react'
import {TwMenuTabs, TwTabs} from './containers'
import {MenuTab, Tab} from './tab'
import {TabsBaseProps} from './types'

export const TabsBase = ({
  tabs,
  activeId,
  onTabClick,
  className,
  type,
  direction,
  slim,
  lineClamp
}: TabsBaseProps) => {
  const TabsWrapper = direction === 'col' ? TwMenuTabs : TwTabs
  const TabComponent = type === 'default' ? MenuTab : Tab

  return (
    <TabsWrapper className={className}>
      {tabs
        .filter(tab => tab.visible === undefined || tab.visible)
        .map(tab => {
          if (tab.separator) {
            return (
              <div key={tab.id} className={tab.className}>
                {tab.title}
              </div>
            )
          }

          return (
            <TabComponent
              key={tab.id}
              {...tab}
              onClick={onTabClick}
              active={tab.id === activeId}
              slim={slim}
              {...(type === 'default'
                ? {
                    lineClamp
                  }
                : undefined)}
            />
          )
        })}
    </TabsWrapper>
  )
}
